import { Controller } from "@hotwired/stimulus"

export default class Loader extends Controller {
  // connect() {
    // globalThis.addEventListener("turbo:load", this.#hideLoader.bind(this));
  // }

  // #hideLoader() {
  //   const loader = document.getElementById("app-loader");
  //   if (loader) loader.classList.add('d-none');

  //   document.body.classList.remove("loading");
  // }
}
